/**
 * Fixes a common LLM Remotion mistake:
 *
 *   <Sequence>
 *     {() => {
 *       return <AbsoluteFill />;
 *     }}
 *     <Audio ... />
 *   </Sequence>
 *
 * React renders function children as invalid children, so the scene visuals
 * disappear while sibling Audio tags still play. Calling the function as an
 * IIFE preserves the intended local-frame block without changing valid code.
 */
export function normalizeRemotionComponentCode(componentCode: string): string {
  return repairJsxFunctionChildren(componentCode);
}

export function hasJsxFunctionChildren(componentCode: string): boolean {
  return /\{\s*\(\s*\)\s*=>\s*\{/.test(componentCode);
}

function repairJsxFunctionChildren(componentCode: string): string {
  if (!hasJsxFunctionChildren(componentCode)) {
    return componentCode;
  }

  return componentCode
    .replace(/\{\s*\(\s*\)\s*=>\s*\{/g, '{(() => {')
    .replace(
      /(\n[ \t]*)\}\}([ \t]*(?:\n[ \t]*(?:<(?:Audio|Img|OffthreadVideo)\b|<\/(?:Sequence|Series\.Sequence)>)))/g,
      '$1})()}$2',
    );
}
